import * as actions from "./Type";
import Instance from "../util/Instance";
import setToken from "../util/SetToken";
import "react-toastify/dist/ReactToastify.css";

// count dashboard cards
export const Count_Agent_Actions = () => {
  return async (dispatch) => {
    if (localStorage.GPC_Agent_token) {
      setToken(localStorage.getItem("GPC_Agent_token"));
    }
    const config = {
      "content-type": "application/json",
    };
    try {
      const res = await Instance.get(`/api/v1/CountAgent`, config);
      dispatch({
        type: actions.COUNT_EVENTS_DASHBOARD,
        payload: res.data.data,
      });
    } catch (error) {}
  };
};
